module.exports = {
	"notification.message": "Wix.com používá soubory cookies, aby vám poskytl nejlepší možný zážitek.",
	"notification.got.it": "Chápu",
	"notification.more.info": "Zjistit více",
	"notification.got.it.arrow": "arrow icon"
};


//////////////////
// WEBPACK FOOTER
// ./assets/locale/messages_cs.json
// module id = 45
// module chunks = 0